export default __webpack_public_path__ + "static/media/Ebony_Whitson_AHV_In_Moms_We_Trust.7db33d83.jpg";